import { mapAtom } from '../../../atoms/map/map'
import { findLayer } from '../../utils/findLayer'

export function changeExecutionEventFeaturesVisibility(visible: boolean) {
  const map = mapAtom.map
  const layer = findLayer(map, 'executionEvents')
  layer.setVisible(visible)
}
